import React, { useCallback, useContext, useEffect, useState } from 'react';
import '../../../libs/bulma.min.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhoneSquare } from '@fortawesome/free-solid-svg-icons';

function TableInterfaces(props) {
  const { iface: { iface, state, link, macaddr, ipaddr } } = props;

  return (
    <tr className='is-size-5 has-text-centered is-family-monospace'>
      <td className='is-uppercase has-text-right'>{ iface.includes('_') ? iface.split('_').join('.') : iface }</td>
      <td>{ macaddr }</td>
      <td>{ ipaddr }</td>
      <td>{ state }</td>
      <td className=''>{ state === 'DOWN' ? null : link }</td>
    </tr>
  );
}

export default TableInterfaces;
